import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { EContexteMesureLingette } from "./enums/context-lingette";

export class MeasureLingette {
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingId!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    TypeSurface?: string;
    @AutoMap()
    ReferenceLot?: string;    
    @AutoMap()
    Temoin?: string;
    @AutoMap()
    VisibilitePoussiere?: boolean;
    @AutoMap()
    SurfacePrelevement?: number;
    @AutoMap()
    Contexte?: EContexteMesureLingette;
    @AutoMap()
    ApresNettoyage?: boolean;
    @AutoMap()
    SampleCode?: string;
}